import fetchSinglepost from '~/utils/api/fetch-singlepost';
import {
  isPreviewPage,
  isArticlePage,
  isHealthArticleOrSubCategoryRoute,
  isHealthCategoryOrPageRoute,
  isAmpPageEndsWith,
  isTheRecipeAmpPage,
  isTheRecipeAmpPath,
} from '~/utils/router';
import { useHealthStore } from '~/store/health';
import removeHostFromUrl from '@devhacker/shared/utils/removeHostFromUrl';
import { fetchArticleData } from '~/utils/api/fetchArticleData';
import { fetchArticlePreviewData } from '~/utils/api/fetchArticlePreviewData';

export default defineNuxtRouteMiddleware(async (to, _from) => {
  if (import.meta.client) return;
  if (useError().value) return;

  if (isAmpPageEndsWith(to.path) && !isTheRecipeAmpPath(to.path)) {
    return fetchSinglepost(to);
  }

  const healthStore = useHealthStore();
  const shouldCheckHealthPage =
    isHealthArticleOrSubCategoryRoute(to.name) || isHealthCategoryOrPageRoute(to.name);

  if (shouldCheckHealthPage) {
    const { $healthApi, $logger } = useNuxtApp();

    const { type, url } = await $healthApi.fetchTypeBySlug(to.path);

    // Correct path of health page
    const correctPath = removeHostFromUrl(url);

    // to.path can have wrong category or subcategory before slug
    if (correctPath !== to.path) {
      $logger('Redirected to correct health path');

      return navigateTo(correctPath, { redirectCode: 301 });
    }

    healthStore.setPageType(type);
  }

  if (
    isArticlePage(to.name) ||
    isPreviewPage(to.name) ||
    healthStore.isHealthArticle ||
    healthStore.isHealthPage
  ) {
    return to.name === 'preview' ? await fetchArticlePreviewData(to) : await fetchArticleData(to);
  }
});
